module.exports = __webpack_public_path__ + "static/img/3.f6ad155.png";


//////////////////
// WEBPACK FOOTER
// ./src/project/articleProject/images/qlxj/3.png
// module id = DPJ/
// module chunks = 6